var $lqx = (function () {
    'use strict';

    /**
     * core.ts - Common functions for $lqx library
     *
     * @version     3.1.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    // Working variables
    const vars = {};
    // Configuration
    const cfg = {};

    /**
     * module.dist.ts - my first module
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2018 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    /**
     * Declare other variables as needed
     */
    const navigation = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.navigation) === null || _a === void 0 ? void 0 : _a.init)
                return; // Change the module name
            vars.navigation = {
                init: false
                /**
                 * Add working variables as needed
                 */
            };
            // Default module configuration
            cfg.navigation = {
                enabled: true
                /**
                 * Add default configuration as needed
                 */
            };
            if (customCfg)
                cfg.navigation = jQuery.extend(true, cfg.navigation, customCfg);
            // Initialize only if enabled
            if (cfg.navigation.enabled) { // Change the module name
                lqx.log('Initializing navigation'); // Change the module name
                /**
                 *
                 * Place here logic that needs to be executed
                 * when the module is first initialized
                 *
                 */
                const menuToggles = document.querySelectorAll('.menu-toggle');
                menuToggles.forEach((toggle) => {
                    toggle.addEventListener('click', function () {
                        var _a, _b;
                        if (document.body.classList.contains('sylp-body--freeze')) {
                            document.body.classList.remove('sylp-body--freeze');
                            (_a = document.querySelector('.sylp-site-header-right')) === null || _a === void 0 ? void 0 : _a.classList.remove('sylp-site-nav--open');
                        }
                        else {
                            document.body.classList.add('sylp-body--freeze');
                            (_b = document.querySelector('.sylp-site-header-right')) === null || _b === void 0 ? void 0 : _b.classList.add('sylp-site-nav--open');
                        }
                    });
                });
                const searchToggles = document.querySelectorAll('.btn-search-toggle');
                const header = document.querySelector('header');
                searchToggles.forEach((toggle) => {
                    toggle.addEventListener('click', function () {
                        var _a, _b;
                        if (header === null || header === void 0 ? void 0 : header.classList.contains('search-open')) {
                            header.classList.remove('search-open');
                            (_a = document.querySelector('.sylp-site-header-right')) === null || _a === void 0 ? void 0 : _a.classList.remove('sylp-site-search--open');
                        }
                        else {
                            header === null || header === void 0 ? void 0 : header.classList.add('search-open');
                            (_b = document.querySelector('.sylp-site-header-right')) === null || _b === void 0 ? void 0 : _b.classList.add('sylp-site-search--open');
                        }
                    });
                });
                // reset the nav menu and search when the screen size changes
                lqx.vars.window.on('screensizechange', () => {
                    var _a, _b;
                    if (document.body.classList.contains('sylp-body--freeze')) {
                        document.body.classList.remove('sylp-body--freeze');
                        (_a = document.querySelector('.sylp-site-header-right')) === null || _a === void 0 ? void 0 : _a.classList.remove('sylp-site-nav--open');
                    }
                    if (header === null || header === void 0 ? void 0 : header.classList.contains('search-open')) {
                        header.classList.remove('search-open');
                        (_b = document.querySelector('.sylp-site-header-right')) === null || _b === void 0 ? void 0 : _b.classList.remove('sylp-site-search--open');
                    }
                });
            }
            // Run only once
            vars.navigation.init = true; // Change the module name
        };
        /**
         *
         * Add other functions, constants and variables as needed by the module
         *
         */
        return {
            init
            /**
             * Add other functions that need to be exposed
             */
        };
    })();

    /**
     * module.dist.ts - my first module
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2018 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    /**
     * Declare other variables as needed
     */
    const impactReport = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.impactReport) === null || _a === void 0 ? void 0 : _a.init)
                return; // Change the module name
            vars.impactReport = {
                init: false
                /**
                 * Add working variables as needed
                 */
            };
            // Default module configuration
            cfg.impactReport = {
                enabled: true
                /**
                 * Add default configuration as needed
                 */
            };
            if (customCfg)
                cfg.impactReport = jQuery.extend(true, cfg.impactReport, customCfg);
            // Initialize only if enabled
            if (cfg.impactReport.enabled) { // Change the module name
                lqx.log('Initializing impactReport'); // Change the module name
                /**
                 *
                 * Place here logic that needs to be executed
                 * when the module is first initialized
                 *
                 */
                if (jQuery('.template-impact-report-page').length) {
                    //padding for scroll and stickyheader
                    const navigationHeight = window.innerWidth <= 1080 ? jQuery('.menu-impact-report').outerHeight() : jQuery('.menu-impact-report .nav-container').outerHeight();
                    document.documentElement.style.setProperty('--scroll-padding', `${navigationHeight - 1}px`);
                    initiateSplitFlap();
                    new Swiper('.swiper.speakers-carousel', {
                        slidesPerView: 1,
                        spaceBetween: 6,
                        loop: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        breakpoints: {
                            640: {
                                slidesPerView: 2
                            },
                            720: {
                                slidesPerView: 3,
                                spaceBetween: 12
                            }
                        }
                    });
                    jQuery('#impact-report-menu-toggle').on('click', () => {
                        jQuery('.menu-impact-report .nav-container').toggleClass('open');
                    });
                    jQuery('.menu-impact-report  li a').on('click', () => {
                        jQuery('.menu-impact-report .nav-container').removeClass('open');
                    });
                    const sylpMap = jQuery('#sylp-map');
                    if (sylpMap.length) {
                        jQuery('#sylp-map [data-state]').each((idx, clickElem) => {
                            const state = jQuery(clickElem).attr('data-state');
                            jQuery(clickElem).on('click', () => {
                                lqx.log(`Click on ${state}`);
                                const element = document.getElementById(`${state}-accordion`);
                                if (element) {
                                    const parent = element.parentElement;
                                    element.scrollIntoView({ behavior: 'smooth' });
                                    //skip the click if the accordion is already expanded
                                    if (parent && parent.getAttribute('aria-expanded') !== 'true') {
                                        element.click();
                                    }
                                }
                                else {
                                    lqx.warn(`Element ${state}-accordion not found`);
                                }
                            });
                        });
                    }
                }
            }
            // Run only once
            vars.impactReport.init = true; // Change the module name
        };
        /**
         *
         * Add other functions, constants and variables as needed by the module
         *
         */
        const initiateSplitFlap = () => {
            const speed = 0.2;
            const char = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0',];
            const random = () => {
                return Math.floor(Math.random() * (99999 - 10000) + 10000).toString();
            };
            const getElementsWithDataNumber = () => {
                const elements = Array.from(document.querySelectorAll('[data-number]'));
                return elements;
            };
            const setupSplitFlapAnimation = (element) => {
                const dataNumber = element.dataset.number;
                if (!dataNumber) {
                    console.error('Element with data-number attribute not found');
                    return;
                }
                const data = [];
                data.push(random());
                data.push(dataNumber);
                const formatted = data.map((n) => n.split(''));
                const startStr = formatted[0];
                const endStr = formatted[formatted.length - 1];
                let long = data[0].length;
                for (const item of data) {
                    long = item.length > long ? item.length : long;
                }
                const amountFlaps = endStr.length; // Change here
                const container = element;
                let html = '';
                // Check if the number has 4 or more digits
                const shouldAddComma = amountFlaps >= 4;
                // Keep track of the position to add the comma
                const commaPosition = amountFlaps - 3;
                for (let i = 0; i < amountFlaps; i++) {
                    // Add the comma element before the appropriate split-flap
                    if (shouldAddComma && i === commaPosition) {
                        html += '<div class="comma">&#44;</div>';
                    }
                    html += `<div class='split-flap'>
						<div class='split-top'></div>
						<div class='split-bottom'></div>
						<div class='split-next-half'></div>
						<div class='split-next-full'></div>
				</div>`;
                }
                if (container !== null) {
                    container.innerHTML = html;
                }
                const splitTop = element.querySelectorAll('.split-top');
                const splitBottom = element.querySelectorAll('.split-bottom');
                const nextFull = element.querySelectorAll('.split-next-full');
                const nextHalf = element.querySelectorAll('.split-next-half');
                for (let x = 0; x < splitTop.length; x++) {
                    splitBottom[x].style.animationDuration = `${speed}s`;
                    nextHalf[x].style.animationDuration = `${speed}s`;
                }
                const start = [];
                const flag = [];
                for (let i = 0; i < amountFlaps; i++) {
                    if (startStr.length !== amountFlaps) {
                        for (let j = 0; j < amountFlaps - startStr.length; j++) {
                            startStr.push('');
                        }
                    }
                    else if (endStr.length !== amountFlaps) {
                        for (let j = 0; j < amountFlaps - endStr.length; j++) {
                            endStr.push('');
                        }
                    }
                }
                for (let i = 0; i < amountFlaps; i++) {
                    start[i] = char.indexOf(startStr[i]);
                    flag[i] = false;
                }
                const startFlip = window.setInterval(() => {
                    for (let i = 0; i < amountFlaps; i++) {
                        if (nextFull[i].innerHTML === endStr[i]) {
                            dontFlipIt(i);
                        }
                        else {
                            flipIt(i);
                        }
                        const ery = flag.every((e) => e);
                        if (ery) {
                            clearInterval(startFlip);
                        }
                    }
                }, speed * 1000);
                const flipIt = (i) => {
                    splitTop[i].innerHTML = char[(start[i] === 0) ? char.length - 1 : start[i] - 1];
                    splitBottom[i].innerHTML = char[(start[i] === 0) ? char.length - 1 : start[i] - 1];
                    nextFull[i].innerHTML = char[start[i]];
                    nextHalf[i].innerHTML = char[start[i]];
                    splitBottom[i].classList.remove('flip-before');
                    void splitBottom[i].offsetWidth; // Trigger reflow
                    splitBottom[i].classList.add('flip-before');
                    nextHalf[i].classList.remove('flip-after');
                    void nextHalf[i].offsetWidth; // Trigger reflow
                    nextHalf[i].classList.add('flip-after');
                    if (start[i] > char.length - 2) {
                        start[i] = 0;
                    }
                    else {
                        start[i]++;
                    }
                };
                const dontFlipIt = (i) => {
                    flag[i] = true;
                    splitBottom[i].classList.remove('flip-after');
                    splitBottom[i].style.backgroundColor = '#fefefe';
                    nextHalf[i].style.backgroundColor = '#fefefe';
                    splitTop[i].innerHTML = char[(start[i] === 0) ? char.length - 1 : start[i] - 1];
                    splitBottom[i].innerHTML = char[(start[i] === 0) ? char.length - 1 : start[i] - 1];
                };
            };
            const elementsWithDataNumber = getElementsWithDataNumber();
            elementsWithDataNumber.forEach((element) => {
                setupSplitFlapAnimation(element);
            });
            const observeElement = (element) => {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            setupSplitFlapAnimation(entry.target);
                            observer.unobserve(entry.target);
                        }
                    });
                }, { threshold: 0.1 } // Adjust this value to control when the animation should trigger
                );
                observer.observe(element);
            };
            getElementsWithDataNumber().forEach((element) => {
                observeElement(element);
            });
        };
        return {
            init
            /**
             * Add other functions that need to be exposed
             */
        };
    })();

    /**
     * scripts.ts - Main file for $lqx project scripts
     *
     * @version     3.1.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    // Declare other variables as needed
    const init = (customCfg) => {
        // Run only once
        if (vars.init)
            return;
        // Extend default config with custom config
        if (typeof customCfg !== 'object')
            customCfg = {};
        const mods = [
            'navigation',
            'impactReport'
            //Add all the custom modules in the appropriate order for initialization
        ];
        console.log('Initializing scripts');
        lqx.log('Custom configuration', customCfg);
        // Initialize modules and pass extended config
        mods.forEach((mod) => {
            $lqx[mod].init(mod in customCfg ? customCfg[mod] : {});
        });
        // Trigger the $lqxready event
        lqx.vars.document.trigger('$lqxready');
        lqx.log('$lqxready Event');
        // Run only once
        vars.init = true;
    };
    // A ready utility function that works like jQuery(document).ready()
    const ready = (callback) => {
        if (vars.init === true) {
            callback();
        }
        else {
            vars.document.on('$lqxready', callback);
        }
    };
    const expObj = Object.defineProperties({
        init,
        ready,
        /* Modules */
        // Add all the custom modules
        navigation,
        impactReport
    }, {
        // Set the cfg and vars properties as read-only
        cfg: {
            get() {
                return cfg;
            },
            set() {
                return undefined;
            }
        },
        vars: {
            get() {
                return vars;
            },
            set() {
                return undefined;
            }
        }
    });

    return expObj;

})();
